import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import MDBox from 'src/components/md/MDBox';
import MDTypography from 'src/components/md/MDTypography';
import MDButton from 'src/components/md/MDButton';
import { PropsWithChildren } from 'react';

const SettingsCardContainer: React.FC<
  PropsWithChildren<{
    id: string;
    title: string;
    subtitle?: string;
    action?: {
      label: string;
      handler: () => void;
    };
    noWrapper?: boolean;
  }>
> = ({ id, title, subtitle, children, action, noWrapper }) => {
  if (noWrapper) {
    return (
      <Grid item xs={12}>
        {children}
      </Grid>
    );
  }

  return (
    <Grid item xs={12}>
      <Card id={id} sx={{ overflow: 'visible' }}>
        <MDBox p={3} lineHeight={1}>
          {
            <MDBox display="flex" justifyContent="space-between">
              <MDBox mb={1}>
                <MDTypography variant="h5">{title}</MDTypography>
              </MDBox>
              {action ? (
                <MDButton color="dark" variant="text" onClick={action.handler}>
                  {action.label}
                </MDButton>
              ) : null}
            </MDBox>
          }
          {subtitle ? (
            <MDTypography variant="button" color="text">
              {subtitle}
            </MDTypography>
          ) : undefined}
        </MDBox>
        {children}
      </Card>
    </Grid>
  );
};

export default SettingsCardContainer;
